<template>
  <v-dialog
    v-model="showCreatePolicy"
    persistent
    width="auto !important"
    class="bg-white pos-relative"
    :content-class="isDarkMode ? 'dark-mode' : ''"
  >
    <v-card>
      <v-card-title class="fs-1-5r bg-grey mb-4">
        Create New Policy
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="policy"
          lazy
          :rules="newPolicyRules"
          class="ma-auto"
          label="Policy Name"
          type="text"
          dense
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-end pa-4">
        <Button
          :clickAction="createNewPolicyClicked"
          text="Create"
          width="100"
          class="mr-4"
          :disabled="isCreateRenameBtnsDisabled"
        >
        </Button>
        <Button
          :clickAction="cancelCreatePolicyClicked"
          text="Cancel"
          btnType="grey"
          width="100"
        >
        </Button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { isFolderNameValid } from '@/utils'

//Components
import Button from '@/components/BaseComponents/Button/Button.vue'

//Component files
import { newPolicyRules } from '../Policies.js'

export default {
  name: 'AddNewPolicy',
  data() {
    return {
      policy: '',
    }
  },
  props: { showCreatePolicy: Boolean },
  emits: ['toggle-is-show-create-policy'],
  components: { Button },
  computed: {
    ...mapGetters(['policies', 'isDarkMode']),
    newPolicyRules,
    isCreateRenameBtnsDisabled() {
      if (!this.policy) return true
      else if (!isFolderNameValid(this.policy)) return true
      else if (this.policies.includes(this.policy)) return true
      return false
    },
  },
  methods: {
    createNewPolicyClicked() {
      this.$router.push(`policies/${this.policy}`)
    },
    cancelCreatePolicyClicked() {
      this.policy = ''
      this.$emit('toggle-is-show-create-policy', false)
    },
  },
}
</script>
